import React, { useMemo } from 'react';
import { VirtualSlotsPlaceholderContext, VirtualSlotsPlaceholderHighlightContext, VirtualSlotsPlaceholderHostId, } from './slotsPlaceholderContext';
import { extractSlotPreviewState, } from './utils/extractSlotPreviewState';
export function withSlotsPlaceholders(Component) {
    return (props) => {
        const { slots, compPreviewState, id, ...otherProps } = props;
        const slotPreviewState = useMemo(() => extractSlotPreviewState(compPreviewState), [compPreviewState]);
        return (React.createElement(VirtualSlotsPlaceholderHostId.Provider, { value: id },
            React.createElement(VirtualSlotsPlaceholderContext.Provider, { value: slots },
                React.createElement(VirtualSlotsPlaceholderHighlightContext.Provider, { value: slotPreviewState },
                    React.createElement(Component, { ...otherProps })))));
    };
}
//# sourceMappingURL=withSlotsPlaceholders.js.map